<template lang="pug">
div
  div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('Who_service_conducter') }}
  div.text-sm.neutral500--text {{ $t('Who_service_conducter_desc') }}

  div.d-flex.align-center(v-if="!disabled")
    v-spacer
    assign-provider-dropdown(:selectedProviders="providers" @added="attachProviders($event)")

  .provider-list
    v-data-table.mt-sm-4.pb-16(:headers="computedHeaders" :items="providers" item-key="id" :items-per-page="-1" :hide-default-header="providers.length === 0 && !isFetching" hide-default-footer disable-sort :loading="isFetching")
      template(v-slot:no-data)
        div.empty-box.mt-6.pa-8(align="center")
          v-avatar(color="neutral300" size="54")
            v-icon(color="neutral500" size="30") $yzi-users-02
          div.text-center.text-md.font-semibold.neutral700--text.mt-8 {{ $t('empty_assign_providers') }}
          div.text-center.text-sm.font-normal.neutral500--text.mt-1 {{ $t('empty_assign_providers_desc') }}
      template(v-if="!disabled" v-slot:item.action="{ item, headers, index }")
        div(align="end")
          v-btn.ml-4(icon small @click="deleteProvider(item)")
            v-icon(color="neutral700" size="18") $yzi-trash-03

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AssignProviderDropdown from '@/components/clinic/appointment/custom/AssignProviderDropdown.vue'

export default {
  name: 'ServiceProvider',
  components: { AssignProviderDropdown },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isFetching: false,
    searchText: '',
    providers: [],
    headers: [
      {
        text: 'Provider',
        value: 'name',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Type',
        value: 'type',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Action',
        value: 'action',
        enable: true,
        class: 'text-xs font-bold text-end neutral500--text text-uppercase'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
      tempLoading: 'clinic/getTempLoading'
    }),
    computedHeaders () {
      if (this.disabled) return this.headers.filter(h => h.value !== 'action')
      return this.headers
    },
    providerData () {
      return {
        providers: this.providers.map(m => m.id)
      }
    }
  },
  watch: {
    providerData: {
      deep: true,
      handler (val) {
        if (this.disabled) return
        this.$store.commit('clinic/updateTempService', val)
      }
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      this.providers = [...service.providers]
    },
    addNewService () {
      this.$emit('addNewService')
    },
    attachProviders (providers) {
      providers.forEach(o => {
        this.providers.push(o)
      })
    },
    deleteProvider (item) {
      this.providers = this.providers.filter(f => f.id !== item.id)
    }
  }
}
</script>

<style scoped>
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
</style>